/* PAVEMOM — product page interactions */

/* ==== Standalone: gallery + quantity (always runs, independent of variant JSON) ==== */
(function () {
  'use strict';
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  var mainImg = pdp.querySelector('[data-main-image]');

  // Delegated click: thumbnails swap the main image
  pdp.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      e.preventDefault();
      swapMain(thumb.getAttribute('data-full'));
      setActiveThumb(thumb);
      return;
    }

    // Colour swatch → swap the gallery image (independent of variant JSON)
    var swatch = e.target.closest('[data-swatch]');
    if (swatch) {
      var target = null;

      // 1) BEST: the exact image Shopify assigned to this colour's variant (set in admin)
      var assigned = swatch.getAttribute('data-variant-image');
      if (assigned) {
        swapMain(assigned);
        // highlight the matching thumbnail if it exists in the gallery
        var thumbsA = allThumbs();
        var tMatch = thumbsA.find(function (t) {
          return sameImage(t.getAttribute('data-full'), assigned);
        });
        if (tMatch) setActiveThumb(tMatch);
        return; // authoritative — done
      }

      // 2) Fallback: match colour name against thumbnail alt text / filename (no position guessing)
      var thumbs = allThumbs();
      if (thumbs.length) {
        var colorName = (swatch.getAttribute('data-color') || swatch.getAttribute('data-value') || '').toLowerCase().trim();
        var aliases = colorAliases(colorName);
        var match = thumbs.find(function (t) {
          var alt = (t.getAttribute('data-media-alt') || '').toLowerCase();
          var url = (t.getAttribute('data-full') || '').toLowerCase();
          return aliases.some(function (a) { return alt.indexOf(a) > -1 || url.indexOf(a) > -1; });
        });
        if (match) { swapMain(match.getAttribute('data-full')); setActiveThumb(match); }
        // If no name match, do NOTHING — never guess by position (avoids showing general images)
      }
      // don't return — let the variant IIFE's own listener also run for price/variant
    }

    // Quantity stepper
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      e.preventDefault();
      var input = pdp.querySelector('[data-qty-input]');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      input.value = plus ? v + 1 : Math.max(1, v - 1);
    }
  });

  function allThumbs() { return Array.prototype.slice.call(pdp.querySelectorAll('[data-thumb]')); }
  function swapMain(src) {
    if (mainImg && src) { mainImg.src = src; mainImg.removeAttribute('srcset'); }
  }
  function setActiveThumb(el) {
    allThumbs().forEach(function (t) { t.classList.toggle('is-active', t === el); });
  }
  // Compare two Shopify image URLs by their base filename (ignore size suffix + query)
  function sameImage(a, b) {
    if (!a || !b) return false;
    return baseName(a) === baseName(b);
  }
  function baseName(url) {
    var file = url.split('?')[0].split('/').pop() || '';
    // strip Shopify size suffix like _1200x or _1200x1200
    return file.replace(/_\d+x\d*(?=\.)/, '').toLowerCase();
  }
  // Return the colour name plus common synonyms, so alt/filename matching is forgiving
  function colorAliases(name) {
    var groups = [
      ['pink', 'blush', 'rose', 'baby pink'],
      ['purple', 'lavender', 'lilac', 'violet'],
      ['sand', 'beige', 'nude', 'skin', 'tan'],
      ['espresso', 'brown', 'coffee', 'chocolate', 'mocha'],
      ['sage', 'green', 'mint'],
      ['charcoal', 'grey', 'gray', 'slate'],
      ['oat', 'oatmeal', 'cream', 'ivory'],
      ['black', 'jet', 'onyx'],
      ['white', 'ivory', 'snow'],
      ['navy', 'blue'],
      ['wine', 'maroon', 'burgundy'],
      ['mustard', 'yellow', 'ochre'],
      ['terracotta', 'rust', 'clay']
    ];
    var found = [name];
    groups.forEach(function (g) {
      if (g.indexOf(name) > -1) { found = found.concat(g); }
    });
    // unique
    return found.filter(function (v, i, a) { return a.indexOf(v) === i; });
  }
})();

/* ==== Variant selection / price / sticky CTA (depends on product JSON) ==== */
(function () {
  'use strict';

  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  var product;
  try {
    var jsonEl = pdp.querySelector('[data-product-json]');
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  var variants = product.variants || [];

  /* Currency formatter using Shopify money format from a rendered price */
  function formatMoney(cents) {
    var amount = (cents / 100);
    // Match the store's rendered currency symbol by reading an existing price node
    var sample = document.querySelector('[data-price]');
    var symbol = '₹';
    if (sample) {
      var m = sample.textContent.trim().match(/^[^\d\-\s]+/);
      if (m) symbol = m[0];
    }
    return symbol + amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  /* ---- Track current selection per option position ---- */
  var selected = (product.options || []).map(function (opt, i) {
    var v = product.selected_or_first_available_variant || variants[0];
    return v && v.options ? v.options[i] : null;
  });

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });
  }

  /* ---- Update all price/CTA nodes for a variant ---- */
  function updateForVariant(variant) {
    var priceEl = pdp.querySelector('[data-price]');
    var compareEl = pdp.querySelector('[data-compare]');
    var saveEl = pdp.querySelector('[data-save]');
    var idEl = pdp.querySelector('[data-variant-id]');
    var atc = pdp.querySelector('[data-atc]');
    var atcText = pdp.querySelector('[data-atc-text]');
    var flag = pdp.querySelector('[data-sale-flag]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyCompare = document.querySelector('[data-sticky-compare]');
    var stickyAtc = document.querySelector('[data-sticky-atc]');

    if (!variant) {
      if (atc) { atc.disabled = true; }
      if (atcText) atcText.textContent = 'Unavailable';
      if (stickyAtc) { stickyAtc.disabled = true; stickyAtc.textContent = 'Unavailable'; }
      return;
    }

    if (idEl) idEl.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compareEl) {
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
    }
    if (stickyCompare) {
      stickyCompare.hidden = !onSale;
      if (onSale) stickyCompare.textContent = formatMoney(variant.compare_at_price);
    }
    if (priceEl) priceEl.classList.toggle('is-sale', onSale);
    if (saveEl) {
      if (onSale) { saveEl.hidden = false; saveEl.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price); }
      else { saveEl.hidden = true; }
    }
    if (flag) flag.style.display = onSale ? '' : 'none';

    if (atc) {
      atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? defaultAtcLabel : 'Sold out';
    }
    if (stickyAtc) {
      stickyAtc.disabled = !variant.available;
      stickyAtc.textContent = variant.available ? defaultAtcLabel : 'Sold out';
    }

    // Update main image to variant's featured image if present
    var main = pdp.querySelector('[data-main-image]');
    if (main && variant.featured_media && variant.featured_media.preview_image) {
      main.src = variant.featured_media.preview_image.src;
      main.removeAttribute('srcset');
      syncActiveThumbBySrc(variant.featured_media.preview_image.src);
    }
  }

  function syncActiveThumbBySrc(src) {
    var base = src.split('?')[0];
    qsa('[data-thumb]').forEach(function (t) {
      var full = (t.getAttribute('data-full') || '').split('?')[0];
      t.classList.toggle('is-active', full === base);
    });
  }

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || pdp).querySelectorAll(sel)); }

  var defaultAtcLabel = (function () {
    var t = pdp.querySelector('[data-atc-text]');
    return t && t.textContent.trim() && t.textContent.trim() !== 'Sold out' ? t.textContent.trim() : 'Add to bag';
  })();

  /* ---- Option button clicks (swatches + sizes) ---- */
  pdp.querySelectorAll('[data-swatch], [data-size]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = parseInt(btn.getAttribute('data-option-position'), 10);
      var val = btn.getAttribute('data-value');
      selected[pos] = val;

      // Update active state within this option group
      var group = btn.parentElement;
      group.querySelectorAll('[data-swatch], [data-size]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      // Update the selected value label
      var optionWrap = btn.closest('[data-option-index]');
      if (optionWrap) {
        var labelEl = optionWrap.querySelector('[data-option-selected]');
        if (labelEl) labelEl.textContent = val;
      }

      updateForVariant(findVariant());
    });
  });

  /* ---- Sticky CTA: show when main ATC scrolls out of view ---- */
  var stickyBar = document.querySelector('[data-sticky-cta]');
  var mainAtc = pdp.querySelector('[data-atc]');
  var stickyAtcBtn = document.querySelector('[data-sticky-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    obs.observe(mainAtc);
  }
  // Sticky button triggers the real form submit
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      var form = document.getElementById('pdp-form');
      if (form && !mainAtc.disabled) {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
    });
  }

  // Initialize
  updateForVariant(findVariant());
})();
/* PAVEMOM — size guide modal */
(function () {
  'use strict';
  var modal = document.querySelector('[data-sizeguide]');
  if (!modal) return;
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sizeguide-open');
    var c = modal.querySelector('[data-sizeguide-close]');
    if (c) c.focus();
  }
  function close() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sizeguide-open');
    if (lastFocus) lastFocus.focus();
  }

  document.querySelectorAll('[data-sizeguide-open]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  modal.querySelectorAll('[data-sizeguide-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });
  // focus trap
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
    var f = modal.querySelectorAll('button, a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();